<div class="col-md-12  justify-content-center">
    <div *ngIf="overlayLayers?.length" class="pt-2">
        <div cdkDropList class="overlay-container"  (cdkDropListDropped)="changeOverlayOrder($event)">
            <div *ngFor="let layer of overlayLayers"
                 cdkDrag>
                <div class="drag-placeholder" *cdkDragPlaceholder></div>
                <app-overlay-layer-item [layer]="layer" (changeChildVisibilityEvent)="changeChildVisibility($event)"
                                        (fitFeatureEvent)="zoomToFeature($event.layer, $event.feature)"
                                        (fitEvent)="fitToBbox($event.bbox, $event.fitOptions)"
                                        (removeLayerEvent)="removeUserLayer($event)"
                                        (editLayerEvent)="editLayer($event)"
                                        (changeVisibilityEvent)="changeVisibility($event)"></app-overlay-layer-item>
            </div>
        </div>
    </div>
</div>
